import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['element'];

	toggle(e) {
		let row = e.target.closest('tr');
		row.classList.toggle('border-b');
		row.classList.toggle('border-neutral-grey');
		row.querySelector('.icon-minus').classList.toggle('hidden');
		row.querySelector('.icon-plus').classList.toggle('hidden');
		row.classList.toggle('border-neutral-grey');
		row.nextElementSibling.classList.toggle('hidden');
		row.nextElementSibling.nextElementSibling.classList.toggle('hidden');
		row.nextElementSibling.nextElementSibling.nextElementSibling.classList.toggle('hidden');
	}
}
